"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapDisplayName = void 0;
/**
 * Get displayName of React component
 * @internal
 */
var getDisplayName = function (Component) {
    return Component.displayName || Component.name || "Component";
};
/**
 * Wrap displayName of React component
 * @internal
 */
exports.wrapDisplayName = function (hocName, BaseComponent) {
    return function (Component) {
        var componentName = getDisplayName(BaseComponent || Component);
        Component.displayName = hocName + "(" + componentName + ")";
        return Component;
    };
};
//# sourceMappingURL=wrapDisplayName.js.map